// extracted by mini-css-extract-plugin
module.exports = {"LabelText":"LabelText_LabelText__2O7Xa"};